export const getBrowserOs = (client) =>
  client?.data?.os.split(" ").slice(0, -1).join(" ");
